import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { DropdownChangeEvent } from 'primeng/dropdown';

@Component({
  selector: 'app-buffer-dropdown-list',
  templateUrl: './buffer-dropdown-list.component.html',
  styleUrls: ['./buffer-dropdown-list.component.css']
})
export class BufferDropdownListRenderer implements ICellRendererAngularComp {
  public params: any;
  public options: Array<any> = [];
  public optionsParam: Array<any> = [];
  public optionValue!: string;
  public optionLabel!: string;
  public disabled: boolean = false;
  public defaultItem: any;
  public filterable: boolean = true;
  public selectedValue: any;
  public columnThatModifies!: string;
  public parent: any;
  width!: number;
  public placeholder: string = '';

  public static readonly VEGETATED_BUFFER_ZONES = [
    {
      Buffer: 0, Values: [
        { field: 'fractionalReductionRunoffVolume', value: 0 },
        { field: 'fractionalReductionRunoffFlux', value: 0 },
        { field: 'fractionalReductionErosionMass', value: 0 },
        { field: 'fractionalReductionErosionFlux', value: 0 }
      ]
    },
    {
      Buffer: 5, Values: [
        { field: 'fractionalReductionRunoffVolume', value: 40 },
        { field: 'fractionalReductionRunoffFlux', value: 40 },
        { field: 'fractionalReductionErosionMass', value: 40 },
        { field: 'fractionalReductionErosionFlux', value: 40 }
      ]
    },
    {
      Buffer: 10, Values: [
        { field: 'fractionalReductionRunoffVolume', value: 60 },
        { field: 'fractionalReductionRunoffFlux', value: 60 },
        { field: 'fractionalReductionErosionMass', value: 85 },
        { field: 'fractionalReductionErosionFlux', value: 85 }
      ]
    },
    {
      Buffer: 15, Values: [
        { field: 'fractionalReductionRunoffVolume', value: 70 },
        { field: 'fractionalReductionRunoffFlux', value: 70 },
        { field: 'fractionalReductionErosionMass', value: 90 },
        { field: 'fractionalReductionErosionFlux', value: 90 }
      ]
    },
    {
      Buffer: 20, Values: [
        { field: 'fractionalReductionRunoffVolume', value: 80 },
        { field: 'fractionalReductionRunoffFlux', value: 80 },
        { field: 'fractionalReductionErosionMass', value: 95 },
        { field: 'fractionalReductionErosionFlux', value: 95 }
      ]
    }
  ];

  constructor() { }

  refresh(): boolean {
    return false;
  }

  agInit(params: any): void {
    this.params = params;
    this.parent = params.context ? params.context : params.instance;
    this.options = params.options;
    this.selectedValue = params.value;
    this.optionValue = params.optionValue;
    this.optionLabel = params.optionLabel;
    this.disabled = params.disabled ?? this.disabled;
    this.columnThatModifies = params.columnThatModifies;
  }

  public onChange({ value }: DropdownChangeEvent): void {
    const values = BufferDropdownListRenderer.getValuesByBuffer(value);
    this.setValue(this.columnThatModifies, value);
    values.forEach((buffer: any) => {
      this.setValue(buffer.field, buffer.value);
    });
  }

  setValue(columnThatModifies: string, value: number): void {
    this.parent.dropDownSelectionChanged({
      field: columnThatModifies, id: this.params.node.id, row: this.params.data, sourceValues: this.options, value: value
    });
  }

  getReadOnlySelectedValue() {
    let value = '';
    if (!this.optionValue || !this.optionValue) {
      value = this.selectedValue;
    } else {
      const option = this.options?.find(option => option[this.optionValue] === this.selectedValue);
      if (option) value = option[this.optionLabel];
    }

    return value;
  }

  public static getValuesByBuffer(buffer: number): any[] {
    const bufferZone = BufferDropdownListRenderer.VEGETATED_BUFFER_ZONES.find(zone => zone.Buffer === buffer);
    return bufferZone ? bufferZone.Values : [];
  }
}